const BASE_URL = "https://c-plus-ingenieria.mybluemix.net/api";
//const BASE_URL = "http://localhost:3000/api";
const CONFIG_API = BASE_URL + "/config";
const CALENDARIO_API = BASE_URL + "/calendario";
const ANUNCIOS_API = BASE_URL + "/anuncios";
const CONSULTAS_API = BASE_URL + "/consultas";
const ASESORES_API = BASE_URL + "/asesores";
//const MATERIAL_API = BASE_URL + "/materiales";
const MATERIAL_API =
	"https://docs.google.com/spreadsheets/d/e/2PACX-1vS2u-XYrTRlzf17YgP3cA75MNuhe2xFRNWQg_-wUXos1-d7fHwZ8PK29L6ZaZKQGbeMWw91bXoqNO_m/pub?output=csv";

const FB_URL = "https://us-central1-centro-plus.cloudfunctions.net/suscribeUserTopics";
//const FB_URL = "http://localhost:5001/centro-plus/us-central1/suscribeUserTopics";

export {
	FB_URL,
	BASE_URL,
	CONFIG_API,
	CALENDARIO_API,
	ANUNCIOS_API,
	CONSULTAS_API,
	ASESORES_API,
	MATERIAL_API,
};
